<template>
  <div id="User" class="card">
      <el-tabs v-model="activeName" type="border-card" @tab-click="handleClick" class="tabs">
        <el-tab-pane v-for="(tab,index) in tables" :label="tab.label" :name="tab.name" :key="tab.name + index" @click="viewPush(tab)" class="tab">

          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item class="firstBread"> {{tab.label}}</el-breadcrumb-item>
            <el-breadcrumb-item v-if="$route.meta.liShow"><span>  贵单位参与投标项目列表如下 </span></el-breadcrumb-item>
            <el-breadcrumb-item v-if="$route.name == 'Instructions'"><span>  请贵单位详细阅知 </span></el-breadcrumb-item>
          </el-breadcrumb>
        </el-tab-pane>
      </el-tabs>
      <el-row ref="form" class="topSearch" v-if="$route.meta.search">
          <el-input placeholder="为空时搜索,显示全部" v-model="$store.state.searchText" class="search" size="mini" @change="enterGoSearch" @keyup.enter.native="goSearch" ></el-input>
          <el-button  size="mini" class="goSearch" @click="goSearch" ref="search" >搜索</el-button>
          
      </el-row> 
      <keep-alive :exclude="$store.state.cachedViews">
        <router-view  ref="child" class="router" :style="{'margin':$route.meta.search?'10px 0 0':'50px 0 0 '}"/>
      </keep-alive>
  </div>
</template>
<script type="text/javascript">
	export default {
		name: 'User',
		data() {
			return {
        searchText:'',  //搜索内容
        
        tables_notline:[
          {label:'平台账号注册',name:'register'},
         
        ],
        activeName:'',
        tabs1:[
           {label:'投标文件上传',name:'upload'},
          {label:'中标结果公示',name:'bidWin'},
          {label:'投标须知',name:'Instructions'},
          {label:'平台账号修改',name:'account'},
        ],
        tabs0:[
           {label:'平台账号管理',name:'manageAdmin'},
          {label:'招采项目新建',name:'newly'},
          {label:'招采项目管理',name:'managePro'},
          {label:'截标下载管理',name:'download'},
          {label:'中标通知管理',name:'notice'},
        ],
        search:'',
			}
		},
		methods: {
      handleClick(tab, event) {
        // console.log(this.activeName);
        // console.log(tab, event);
        this.$router.push({name:tab.name});
        
      },
      viewPush(tab){
        this.$router.push({name:tab.name});
      },
      enterGoSearch(){

          this.$refs.search.$el.click();
      },
      goSearch(){
        // 子路由定义搜索方法searchMenu，便于搜索
        let searchText = this.$store.state.searchText;
        this.$refs.child.searchMenu(searchText);
      }
			
    },
    created(){
      
      this.activeName = this.$route.name;
    },
    mounted() {
			
    },
    destroyed(){

    },
    computed:{
      online(){
          return this.$store.getters.online;
      },
      types(){
          return this.$store.state.user.types;
      },
      tables(){
        if(this.online && this.$route.meta.requireAuth){
          switch(this.types){
            case 'user':
                return this['tabs1']
              break
            default:
                return this['tabs0']
              break 
          }

        }else{
          return this.tables_notline
        }
      }
      
    },
    watch:{
      activeName(n,o){
      },
     
    }
	}
</script>

<style scoped>
  .card{
    position: relative;
  }
  .tabs{
    display: block;
    width: 100%;
    height: 35px;
    color: red;

  }
  .tab{
    color: white;
  }
  .firstBread{
    font-weight: 700;
  }
  
  .topSearch{
      display: flex;
      width:calc(100% - 350px);
      margin:10px 0 0 350px;
  }
  .search{
    width: calc(100% - 500px);
  }
  .goSearch{
    width: 100px;
    margin-left: 50px;
  }
  .router{
    width: 100%;
    height: calc(100% - 80px);
    overflow: auto;
  }
  .refresh{
  }
  
</style>

